
import '../../Pages/Client/AO/AODetails.scss';
import '../../Pages/Client/AO/Alertes.scss';

//import { ROLES } from './config';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, Dialog, IconButton, Toolbar } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import { ROLES } from '../../config';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useFormValidation from '../../hooks/useFormValidation';
import usePostRequest from '../../hooks/usePostRequest';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { requiredColorCode } from '../../Styles/componentStyles';
import { isHttpStatusSuccess, roleCollab } from '../../Utils/utils';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';

{/*mode==ajouter c pour ajouter un collaborateur*/ }
{/*mode==editer c pour editer les roles d'un collaborateur*/ }
function DialogValiderBackOffice({ open, setOpen, rowSelected, title, mode, getMyCollaborators }) {
    DialogValiderBackOffice.propTypes = {
        open: PropTypes.any,
        rowSelected: PropTypes.any,
        setOpen: PropTypes.func,
        getMyCollaborators: PropTypes.func,
        mode: PropTypes.any,
        title: PropTypes.any,
    };
    const {setShowErrors, setErrors, showErrors} = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    const {postData} = usePostRequest();
    const [email, setEmail] = useState('');
    const [nom, setNom] = useState('');
    const [prenom, setPrenom] = useState('');
    const [tele, setTele] = useState('');
    const { i18n } = useTranslation();
    const [roles, setRoles] = useState({ littleAdmin: '', chargeRecrutement: '', Comptable: '', });

    const [isValid] = useFormValidation([
        { name: 'nom', value: nom },
        { name: 'prenom', value: prenom },
        { name: 'email', value: email },
    ]);

    const hasSelectedRole = useMemo(() => Object.values(roles).some(val => {
        if (typeof val === 'boolean') {
            return val === true;
        }
        return val.trim() !== '';
    }), [roles]);

    useEffect(() => {
        if (rowSelected) {
            console.log('rowSelected rowSelected',rowSelected);
            setEmail(rowSelected?.email_);
            setNom(rowSelected?.nom);
            setPrenom(rowSelected?.prenom);
            setTele(rowSelected?.tele);
            //console.log('rowselecte', rowSelected);
            setRoles({
                Admin: roleCollab(rowSelected?.role?.Admin),
                littleAdmin: roleCollab(rowSelected?.role?.littleAdmin),
                chargeRecrutement: roleCollab(rowSelected?.role?.chargeRecrutement),
                Comptable: roleCollab(rowSelected?.role?.Comptable),
            });
        }
    }, [rowSelected]);

    const updateCollabStatus = async () => {
        var nombreRoleAffectees = Object.values(roles).filter(object => object == 1).length;
        if (nombreRoleAffectees >= 1) {
            try {
                const response = await axiosPrivate.post(
                    '/admin/switchRoles', {
                        backOfficeEmail: rowSelected?.email_ ?? email,
                        roles: roles,
                        nom, prenom, tele,
                    });
                if (isHttpStatusSuccess(response?.status)) {
                    console.log('response 12', response);
                    getMyCollaborators();
                    handleClose();
                }
            } catch (error) {
                console.log(error);
                console.log(error.response.data?.error);
            }
        }
        else {
            Swal.fire('error occured', 'Il faut au minimum garder un seul rôle affecté !', 'error');
        }
    };

    const enovoyerInv = async () => {
        try {
            const response = await postData({url:'admin/inviteBackOfficeByHTHAdmin', payload:{
                role: ROLES.Admin, email, nom, prenom, tele,
            }});
            console.log(response.data);
            if (isHttpStatusSuccess(response.responseStatus)) {
                // handleClose();
                console.log('added');
            }
        } catch (error) {
            console.log(error);
        }
    };
    const handleClose = () => {
        setOpen(false);
        setEmail('');
        setNom('');
        setPrenom('');
        setTele('');
        setRoles({ littleAdmin: '', chargeRecrutement: '', Comptable: '', });
    };
    const scroll = 'paper';
    const useStyles = makeStyles({
        menuPaper: {
            borderRadius: 0, // Set borderRadius to 0 or 'none' to remove the rounded corners
        },
    });

    const classes = useStyles();
    const {device}=useWindowSize();
    return (
        <Dialog
            fullScreen
            open={open}
            TransitionComponent={Transition}
            onClose={handleClose}
            scroll={scroll}
            PaperProps={{
                style: {
                    background: '#F5F6FA',
                    borderRadius: 0,
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar
                style={{
                    borderRadius: '0',
                }}
                classes={{ paper: classes.menuPaper }}
            >
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', background: '#F5F6FA', paddingTop: '90px', paddingLeft:device=='desktop'?'24px':'0px', paddingBottom: '24px' }}>
                <div className='frame0FicheCollab'>
                    <h4 className='frame1FicheCollab'>{title}</h4>
                    {mode != 'ajouter' &&
                        <div className='frame2FicheCollab'>
                            <div className='frame3FicheCollab'>
                                <img
                                    src={rowSelected?.img}
                                    style={{ width: '100px', height: '100px', borderRadius: '20px' }}
                                />
                            </div>
                            <div className='frame4FicheCollab'>
                                <div className='frame5FicheCollab'>
                                    <h5 className='frame6FicheCollab'>{nom + ' ' + prenom}</h5>
                                    <b className='frame7FicheCollab'>{rowSelected?.email_}</b>
                                </div>
                            </div>
                        </div>
                    }
                    <div className='frame8FicheCollab'>
                        <div className='frame9FicheCollab'>
                            <div className='frame10FicheCollab'>
                                <div className='frame11FicheCollab'>
                                    <TextFieldComponent
                                        id="outlined-name"
                                        label={i18n.t('Prénom')}
                                        name='prenom'
                                        value={prenom}
                                        onChange={(e) => setPrenom(e.target.value)}
                                        // disabled={mode == 'ajouter' ? false : true}
                                        style={{ width: '100%',backgroundColor: 'white' }}
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px' },
                                        }}
                                    />
                                </div>
                                <div className='frame12FicheCollab'>
                                    <TextFieldComponent
                                        id="outlined-name"
                                        label={i18n.t('Nom')}
                                        name='nom'
                                        value={nom}
                                        onChange={(e) => setNom(e.target.value)}
                                        // disabled={mode == 'ajouter' ? false : true}
                                        style={{ width: '100%',backgroundColor: 'white' }}
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px' },
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='frame10FicheCollab'>
                                <div className='frame11FicheCollab'>
                                    <TextFieldComponent
                                        id="outlined-name"
                                        name='email'
                                        label={i18n.t('E-mail')}
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        disabled={mode == 'ajouter' ? false : true}
                                        style={{ width: '100%',backgroundColor: 'white' }}
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px' },
                                        }}
                                    />
                                </div>
                                <div className='frame12FicheCollab'>
                                    <TextFieldComponent
                                        id="outlined-name"
                                        label ={i18n.t('Téléphone')}
                                        value={tele}
                                        type='text'
                                        onChange={(e) => setTele(e.target.value)}
                                        // disabled={mode == 'ajouter' ? false : true}
                                        style={{ width: '100%',backgroundColor: 'white' }}
                                        sx={{
                                            '& > :not(style)': {  borderRadius: '8px' },
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='frame14FicheCollab'>
                                <h6 className='frame15FicheCollab'>
                                    {i18n.t('Le collaborateur a comme rôle:')}
                                </h6>
                                <p
                                    className='frame15FicheCollab'
                                    style={{color: requiredColorCode}}
                                >{!hasSelectedRole && showErrors && 'Vous devez au moins sélectionner un rôle'}</p>
                                <div className='frame19FicheCollab'>
                                    <div className='frame17FicheCollab'>
                                        <div className='frame29DonneeFacturation'>
                                            <input
                                                type='checkbox'
                                                style={{
                                                    width: '24px',
                                                    height: '24px',
                                                    borderRadius: '8px'
                                                }}
                                                //{...labelcheckbox}
                                                checked={(roles?.littleAdmin || roles?.Admin) ? true : false}
                                                value={roles?.littleAdmin}
                                                onChange={(e) => {
                                                    setRoles({ ...roles, littleAdmin: e.target.checked });
                                                }}
                                                disabled={((mode == 'editer' && roles?.Admin == 0) || mode == 'ajouter') ? false : true}
                                            />
                                        </div>
                                        <b className='frame30DonneeFacturation'>{i18n.t('Admin')}</b>
                                    </div>
                                    <div className='frame18FicheCollab'>
                                        <div className='frame29DonneeFacturation'>
                                            <input
                                                type='checkbox'
                                                style={{
                                                    width: '24px',
                                                    height: '24px',
                                                    borderRadius: '8px'
                                                }}
                                                checked={roles['Comptable']}
                                                value={roles?.Comptable}
                                                onChange={(e) => {
                                                    //console.log('e.target.checked', e.target.checked);
                                                    setRoles({ ...roles, Comptable: e.target.checked });
                                                }}
                                                disabled={(mode == 'editer' || mode == 'ajouter') ? false : true}
                                            />
                                        </div>
                                        <b className='frame30DonneeFacturation'>{i18n.t('Comptable')}</b>
                                    </div>
                                </div>
                                <div className='frame19FicheCollab'>
                                    <div className='frame17FicheCollab'>
                                        <div className='frame29DonneeFacturation'>
                                            <input
                                                type='checkbox'
                                                style={{
                                                    width: '24px',
                                                    height: '24px',
                                                    borderRadius: '8px'
                                                }}
                                                checked={roles?.chargeRecrutement}
                                                value={roles?.chargeRecrutement}
                                                onChange={(e) => {
                                                    setRoles({ ...roles, chargeRecrutement: e.target.checked });
                                                }}
                                                disabled={(mode == 'editer' || mode == 'ajouter') ? false : true}
                                            />
                                        </div>
                                        <b className='frame30DonneeFacturation'>{i18n.t('Chargé de Recrutement')}</b>
                                    </div>
                                </div>
                            </div>
                            {mode == 'editer' &&
                                <div style={{ display: 'flex', flexDirection:device=='desktop'?'row':'column', gap: '24px', justifyContent: 'flex-end', alignSelf: 'stretch',width:device=='desktop'?'auto':'100%' }}>
                                    <Button
                                        variant='text'
                                        style={{ ...buttonStyles(),...{width:device=='desktop'?'auto':'100%'} }}
                                        onClick={handleClose}
                                    >
                                        {i18n.t('Annuler')}
                                    </Button>
                                    <Button
                                        variant='contained'
                                        style={{ ...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'} }}
                                        onClick={() => {
                                            updateCollabStatus();
                                        }}
                                    >
                                        {i18n.t('Enregistrer')}
                                    </Button>
                                </div>
                            }
                            {mode == 'ajouter' &&
                                <div style={{ display: 'flex', flexDirection: device=='desktop'?'row':'column', gap: '24px', justifyContent: 'flex-end', alignSelf: 'stretch',width:'100%' }}>
                                    <Button
                                        variant='text'
                                        style={{ ...buttonStyles(),...{width:device=='desktop'?'auto':'100%'} }}
                                        onClick={handleClose}
                                    >
                                        {i18n.t('Annuler')}
                                    </Button>
                                    <Button
                                        variant='contained'
                                        style={{ ...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'} }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (isValid && hasSelectedRole) {
                                                enovoyerInv().then(() =>{
                                                    updateCollabStatus();
                                                });
                                                setShowErrors(false);
                                                setErrors({});
                                            }
                                            else setShowErrors(true);
                                        }}
                                    >
                                        {i18n.t('Ajouter')}
                                    </Button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default DialogValiderBackOffice;